import { ReactNode } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import View from '../atoms/view';
import SideBar from '../organisms/sideBar';
import SideBarLink from '../organisms/sideBarLink';
import MainContainer from '../organisms/mainContainer';
import { SidebarCategory } from '../../constants/sidebarContent';
import { ThemesProp, ThemedStyleProps } from '../../types/fela';

const themes: ThemesProp = { device: 'desktop' };

type SidebarLayoutProps = {
  children: ReactNode;
  selected: [number, number] | null;
  onSelect: (selection: [number, number]) => void;
  sidebarContent: SidebarCategory[];
};

const SidebarLayout = ({ children, selected, onSelect, sidebarContent }: SidebarLayoutProps) => {
  const { user } = useAuth0();

  return (
    <View extend={styles.shell}>
      <SideBar themes={themes} extend={styles.sidebar}>
        {sidebarContent.map((category, catIndex) => (
          <SideBarLink
            key={catIndex}
            category={category}
            catIndex={catIndex}
            selected={selected}
            onClick={onSelect}
            userId={user?.sub}
          />
        ))}
      </SideBar>
      <MainContainer themes={themes} extend={[styles.main]}>
        {children}
      </MainContainer>
    </View>
  );
};

const styles = {
  shell: ({ theme: { colors } }: ThemedStyleProps) => ({
    flex: 1,
    minHeight: 0,
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    overflow: 'hidden',
    backgroundColor: colors.offWhite,
  }),
  sidebar: ({ theme: { colors } }: ThemedStyleProps) => ({
    width: '184px',
    overflowY: 'auto',
    padding: '42px 8px',
    backgroundColor: colors.white,
    '> a': {
      paddingTop: '8px',
      transition: 'color 200ms ease-in-out',
      '&:hover': {
        color: colors.primary,
      },
      '&:active': {
        color: colors.white,
      },
    },
  }),
  main: {
    padding: '0 16px',
  },
};

export default SidebarLayout;
